module.exports = __webpack_public_path__ + "img/friend-vbet-pc.659a95f7.png";